import { render, staticRenderFns } from "./alertUpdate.vue?vue&type=template&id=1979d6a4&scoped=true"
import script from "./alertUpdate.vue?vue&type=script&lang=js"
export * from "./alertUpdate.vue?vue&type=script&lang=js"
import style0 from "./alertUpdate.vue?vue&type=style&index=0&id=1979d6a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979d6a4",
  null
  
)

export default component.exports